exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a {\n  text-decoration: none; }\n\nli a {\n  width: 100%;\n  height: 100%; }\n\na:link {\n  color: #ffffff; }\n\na:visited {\n  color: #ffffff; }\n\n.outside:link {\n  color: #aaeeee; }\n\n.outside:visited {\n  color: #aaeeee; }\n\n.pic_up:link, .pic_up:visited, .pic_up {\n  color: #eda773; }\n", ""]);

